import gql from 'graphql-tag'

export default gql`
    query ValidateNonManualVoucher($input: ValidateNonManualVoucherInput!) {
        validateNonManualVoucher(input: $input) {
            code
            id
            type
            name
            articleNumber
            infoText
            products {
                articleId
                name
                price
                type
            }
            actions {
                articleId
                name
                price
                type
            }
            value {
                currency
                discountType
                month
                value
            }
        }
    }
`
